function SearchInput({interval,list,$el}) {
   this.$el = $el;
   this.interval = interval || 10000;
   this.list = list; 
   this.index = 0;
}
SearchInput.prototype.start=function() {
    this.startTime = Date.now();
    requestAnimationFrame(delay.bind(this));
}
const delay = function() {
    let curTime = Date.now();
    if (curTime - this.startTime > this.interval) {
        this.startTime = curTime;
        this.render();
    }
    requestAnimationFrame(delay.bind(this));
}
SearchInput.prototype.render=function(){
   const pos = this.index%this.list.length;
   this.index++;
   this.$el.setAttribute('placeholder',this.list[pos]); 
}
export default SearchInput


// WEBPACK FOOTER //
// ./src/JS/SearchInput/index.js